export default {"src":"/_next/static/media/gray-entry-point.16a8ee42.svg","height":2324,"width":2324,"blurWidth":0,"blurHeight":0};